import request from '@/utils/request2'

// 列表(主数据列表)
export function loadBusinessDistrictSettingListDataApi(data) {
  return request({
    url: 'tms-web/businessDistrictSetting/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportBusinessDistrictSettingListDataApi(data) {
  return request({
    url: 'tms-web/businessDistrictSetting/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveBusinessDistrictSettingApi(data) {
  return request({
    url: 'tms-web/businessDistrictSetting/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteBusinessDistrictSettingApi(data) {
  return request({
    url: 'tms-web/businessDistrictSetting/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewBusinessDistrictSettingApi(data) {
  return request({
    url: 'tms-web/businessDistrictSetting/view',
    method: 'post',
    data
  })
}

// 列表
export function listBusinessDistrictSettingApi(data) {
  return request({
    url: 'tms-web/businessDistrictSetting/list',
    method: 'post',
    data
  })
}
